import articlePage from "@faire/web-api/routes/support/articles/articleId";
import { Button } from "@faire/web/slate/Button";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { MessageRetailerOrBrandButton, additionalDataRequiredForContactingRetailerOrBrandCTA } from "../../shared/instantAnswerUtils";
import { CreateReturnCTA } from "./ctas";
import { NEED_MORE_INFO_ANSWER } from "./shared";
export var CreateReturnIA = function CreateReturnIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2, context.brandOrder);
      }
    },
    secondaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _MessageRetailerOrBra;
        return (_MessageRetailerOrBra = MessageRetailerOrBrandButton(context, strictLocalize)) === null || _MessageRetailerOrBra === void 0 ? void 0 : _MessageRetailerOrBra.label;
      },
      onClickFunctionBuilder: function onClickFunctionBuilder(context) {
        var _MessageRetailerOrBra2;
        return (_MessageRetailerOrBra2 = MessageRetailerOrBrandButton(context, strictLocalize)) === null || _MessageRetailerOrBra2 === void 0 ? void 0 : _MessageRetailerOrBra2.onClick;
      }
    },
    additionalRequiredData: additionalDataRequiredForContactingRetailerOrBrandCTA()
  };
};
var getAnswer = function getAnswer(context, strictLocalize) {
  var brandOrder = context.brandOrder,
    shippingContext = context.shippingContext;
  if (!brandOrder || !shippingContext) {
    return NEED_MORE_INFO_ANSWER(strictLocalize);
  }
  return shippingContext.is_return_eligible ? RETURN_ELIGIBLE(strictLocalize) : RETURN_INELIGIBLE(strictLocalize);
};
var getPrimaryCTA = function getPrimaryCTA(context, strictLocalize) {
  var brandOrder = context.brandOrder,
    shippingContext = context.shippingContext;
  if (!brandOrder || !shippingContext || !shippingContext.is_return_eligible) {
    return undefined;
  }
  return CreateReturnCTA(strictLocalize);
};
var RETURN_ELIGIBLE = function RETURN_ELIGIBLE(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return ELIGIBLE_FOR_FREE_RETURN(strictLocalize);
    },
    getDescription: function getDescription() {
      return [FREE_RETURNS_FOR_60_DAYS(strictLocalize)];
    }
  };
};
var RETURN_INELIGIBLE = function RETURN_INELIGIBLE(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return NOT_ELIGIBLE_FOR_FREE_RETURN(strictLocalize);
    },
    getDescription: function getDescription() {
      return /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
        id: "xp370T",
        defaultMessage: "Free returns are only eligible on your first order with a brand and must be initiated within 60 days from the order date. <CertainProductLinkFormatting>Certain products</CertainProductLinkFormatting> are also ineligible for returns, such as seasonal products. Read more about our <ReturnPolicyLinkFormatting>return policy</ReturnPolicyLinkFormatting> or message the brand to discuss alternative options.",
        values: {
          CertainProductLinkFormatting: LinkFormatting(articlePage("360007069352")),
          ReturnPolicyLinkFormatting: LinkFormatting(articlePage("360002924031"))
        }
      }));
    }
  };
};
var ELIGIBLE_FOR_FREE_RETURN = function ELIGIBLE_FOR_FREE_RETURN(strictLocalize) {
  return strictLocalize({
    id: "qLHIz7",
    defaultMessage: "You’re eligible for a free return!"
  });
};
var FREE_RETURNS_FOR_60_DAYS = function FREE_RETURNS_FOR_60_DAYS(strictLocalize) {
  return strictLocalize({
    id: "Y812Kt",
    defaultMessage: "We offer free returns for 60 days from the date the order is shipped on the first order you place with any brand. Create a return or read more about our return policy by checking out the recommended article from our Help Center below."
  });
};
var NOT_ELIGIBLE_FOR_FREE_RETURN = function NOT_ELIGIBLE_FOR_FREE_RETURN(strictLocalize) {
  return strictLocalize({
    id: "KqoKJ5",
    defaultMessage: "This order isn’t eligible for a return"
  });
};
var LinkFormatting = function LinkFormatting(linkTo) {
  return function (chunks) {
    return /*#__PURE__*/React.createElement(Button, {
      linkTo: linkTo,
      variant: "tertiary"
    }, chunks);
  };
};